import React from 'react';
import { Helmet } from 'react-helmet-async';
import { ServiceSchema, BreadcrumbSchema } from '@/components/seo/SchemaMarkup';

const CosmeticDentistry = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* SEO Meta Tags */}
      <Helmet>
        <title>Cosmetic Dentistry Fort Worth TX | Smile Makeover | Fort Worth Dental</title>
        <meta name="description" content="Transform your smile with cosmetic dentistry in Fort Worth TX. Veneers, teeth whitening, smile makeovers, and more. Free consultation. Call (817) 985-3337." />
        <meta name="keywords" content="cosmetic dentistry fort worth, smile makeover fort worth tx, porcelain veneers, teeth whitening, first fit veneers, cosmetic dentist" />
        <link rel="canonical" href="https://fortworthdental.com/cosmetic-dentistry" />
      </Helmet>
      
      {/* Schema.org Structured Data */}
      <ServiceSchema 
        serviceName="Cosmetic Dentistry"
        description="Complete smile makeovers and cosmetic dental treatments in Fort Worth TX. Veneers, teeth whitening, First Fit Veneers and more."
        url="https://fortworthdental.com/cosmetic-dentistry"
      />
      <BreadcrumbSchema items={[
        { name: "Home", url: "https://fortworthdental.com/" },
        { name: "Cosmetic Dentistry", url: "https://fortworthdental.com/cosmetic-dentistry" }
      ]} />
      
      <section className="bg-gradient-to-br from-teal-600 to-teal-800 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-6">Cosmetic Dentistry</h1>
          <p className="text-xl max-w-3xl mx-auto">Is It Time For A Complete Smile Makeover?</p>
        </div>
      </section>

      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-6">Let Fort Worth Dental Provide You the Perfect Long Lasting Solution</h2>
            <p className="text-gray-700 text-lg leading-relaxed mb-4">
              A person's smile is a defining and memorable characteristic, so disliking how your teeth look can leave you feeling 
              perpetually embarrassed or self-conscious. You may cover your mouth when you laugh or talk. Or maybe you can't remember 
              the last time you smiled openly for a photo.
            </p>
            <p className="text-gray-700 text-lg leading-relaxed">
              If this is the case with you, a smile makeover can improve your appearance, confidence, and self-esteem! Do you have gaps 
              in your teeth? Crooked teeth? Chipped or cracked teeth? How about discolored, cracked or missing teeth? Fort Worth Dental's 
              smile makeover corrects one or all of these problems you may be experiencing.
            </p>
          </section>

          <section className="bg-teal-50 p-8 rounded-lg mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-6">Dental Treatments We Personalize To Your Needs:</h2>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-700">
              <li className="flex items-start">
                <span className="text-teal-600 mr-2">•</span>
                <span>Teeth Whitening – Professional Zoom treatments or Overnight custom trays</span>
              </li>
              <li className="flex items-start">
                <span className="text-teal-600 mr-2">•</span>
                <span>Invisalign® - Invisible teeth straightening – no metal braces needed</span>
              </li>
              <li className="flex items-start">
                <span className="text-teal-600 mr-2">•</span>
                <span>CEREC Same-Day Crowns</span>
              </li>
              <li className="flex items-start">
                <span className="text-teal-600 mr-2">•</span>
                <span>Crowns and Bridges – affordable options</span>
              </li>
              <li className="flex items-start">
                <span className="text-teal-600 mr-2">•</span>
                <span>Porcelain Veneers – Beautiful smile finish</span>
              </li>
              <li className="flex items-start">
                <span className="text-teal-600 mr-2">•</span>
                <span>Dental Implants – permanent solution</span>
              </li>
            </ul>
          </section>

          <section className="text-center bg-gradient-to-r from-teal-600 to-teal-700 text-white p-12 rounded-lg mb-12">
            <h2 className="text-3xl font-bold mb-4">Ready to Transform Your Smile?</h2>
            <p className="text-xl mb-8">Schedule your consultation today!</p>
            <a href="tel:8179853337" className="bg-white text-teal-600 px-8 py-4 rounded-lg text-lg font-bold hover:bg-gray-100 inline-block">
              Call (817) 985-3337
            </a>
          </section>

          {/* Related Blog Posts - Internal Links for SEO */}
          <section className="mb-12 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-amber-50 border border-amber-200 p-6 rounded-lg">
              <h3 className="text-xl font-bold text-gray-800 mb-3">📖 Have a Gap Between Your Teeth?</h3>
              <p className="text-gray-700 mb-3 text-sm">
                Learn about all your options for closing gaps - from veneers to Invisalign.
              </p>
              <a 
                href="/blogs/how-to-fix-gap-between-front-teeth" 
                className="inline-flex items-center text-teal-600 font-semibold hover:text-teal-800 text-sm"
              >
                How to Fix a Gap Between Front Teeth →
              </a>
            </div>
            <div className="bg-purple-50 border border-purple-200 p-6 rounded-lg">
              <h3 className="text-xl font-bold text-gray-800 mb-3">⭐ First Fit Veneers - NEW!</h3>
              <p className="text-gray-700 mb-3 text-sm">
                Revolutionary same-day veneers technology. Get a brand new smile in just 2 hours!
              </p>
              <a 
                href="/first-fit-veneers" 
                className="inline-flex items-center text-teal-600 font-semibold hover:text-teal-800 text-sm"
              >
                Learn About First Fit Veneers →
              </a>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CosmeticDentistry;
